import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import NavBar from "../components/NavBar";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

const AdminResetPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@dayzdrip.gg");
  const [password, setPassword] = useState("");
  const [resetKey, setResetKey] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/admin-reset", {
        email: email.trim(),
        new_password: password,
        reset_key: resetKey.trim(),
      });
      toast.success("Admin password reset — you can now log in with the new password.");
      setTimeout(() => navigate("/admin/login"), 1200);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950">
      <NavBar />
      <div className="max-w-md mx-auto px-4 py-20">
        <div className="border-2 border-red-900/60 bg-red-950/10 p-6 sm:p-8 brutal-shadow" data-testid="admin-reset-page">
          <div className="flex items-center gap-2 mb-4">
            <KeyRound className="w-5 h-5 text-red-500" />
            <span className="font-mono-tech text-xs uppercase text-red-400">// EMERGENCY RESET</span>
          </div>
          <h1 className="font-display text-3xl sm:text-4xl text-zinc-50 uppercase leading-none">Admin Reset</h1>
          <p className="mt-3 font-mono-tech text-[11px] text-zinc-400 uppercase leading-relaxed">
            // For emergencies only. Requires your server reset key (SERVER_INGEST_KEY env value).
          </p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="font-mono-tech text-xs uppercase text-zinc-400 mb-1 block">Admin Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoCapitalize="none" autoCorrect="off" spellCheck={false} data-testid="reset-email" className="w-full bg-zinc-900 border-2 border-zinc-800 focus:border-red-600 focus:outline-none px-3 py-2 font-mono-tech text-sm text-zinc-100" />
            </div>
            <div>
              <label className="font-mono-tech text-xs uppercase text-zinc-400 mb-1 block">New Password (min 6, case-sensitive)</label>
              <input type="text" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} autoCapitalize="none" autoCorrect="off" spellCheck={false} data-testid="reset-password" className="w-full bg-zinc-900 border-2 border-zinc-800 focus:border-red-600 focus:outline-none px-3 py-2 font-mono-tech text-sm text-zinc-100" />
            </div>
            <div>
              <label className="font-mono-tech text-xs uppercase text-zinc-400 mb-1 block">Reset Key</label>
              <input type="text" value={resetKey} onChange={(e) => setResetKey(e.target.value)} required autoCapitalize="none" autoCorrect="off" spellCheck={false} data-testid="reset-key" className="w-full bg-zinc-900 border-2 border-zinc-800 focus:border-red-600 focus:outline-none px-3 py-2 font-mono-tech text-sm text-zinc-100" />
              <div className="mt-1 font-mono-tech text-[10px] text-zinc-500 uppercase break-all">// Value of SERVER_INGEST_KEY from your backend .env</div>
            </div>
            <button type="submit" disabled={loading} data-testid="reset-submit" className="w-full bg-red-600 hover:bg-red-500 disabled:opacity-60 text-zinc-50 px-6 py-3 font-display text-base sm:text-lg tracking-widest uppercase transition-all">
              {loading ? "..." : "Reset Admin Password"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminResetPage;
